






























































































































































































































































import Vue from 'vue';
import _ from 'lodash';

import { Paciente } from '../../../../back/src/entity/Paciente';
import { Internacao } from '../../../../back/src/entity/Internacao';

import CustomDialog from '../CustomDialog.vue';
import IfEmptyTextPrintNA from '../IfEmptyTextPrintNA.vue';
import InformacoesPartosTabela from '../informacoes_partos/InformacoesPartosTabela.vue';
import TheInternacoesNovaForm from '../internacoes/TheInternacoesNovaForm.vue';

import { egbStrings } from '../../utils/constants';
import { Egb } from '../../../../back/src/types';

export default Vue.extend({
  name: 'ThePacientesDadosInternacoes',
  components: {
    CustomDialog,
    IfEmptyTextPrintNA,
    InformacoesPartosTabela,
    TheInternacoesNovaForm,
  },
  props: {
    paciente: {
      type: Object as () => Paciente,
    },
    internacoes: {
      type: Array as () => Internacao[],
    },
  },
  data() {
    return {
      dialogInternacao: false,
      showAgendadas: true,
      showAtivas: true,
      showFinalizadas: true,
      expandedAtivas: [],
      expandedFinalizadas: [],
      headersAgendadas: [
        {
          value: 'datetime_agendamento',
          text: 'Data agendada',
          class: 'text-no-wrap',
          sortable: false,
        },
        {
          value: 'local',
          text: 'Local',
          class: 'text-no-wrap',
          sortable: false,
        },
        {
          value: 'quarto',
          text: 'Quarto',
          class: 'text-no-wrap',
          sortable: false,
        },
        {
          value: 'motivo',
          text: 'Motivo',
          class: 'text-no-wrap',
          sortable: false,
        },
        {
          value: 'actions',
          text: 'Ver agendamento',
          class: 'text-no-wrap text-center',
          width: 1,
          sortable: false,
        },
      ],
      headersAtivas: [
        {
          value: 'datetime_internacao',
          text: 'Data agendada',
          class: 'text-no-wrap',
          sortable: false,
        },
        {
          value: 'local',
          text: 'Local',
          class: 'text-no-wrap',
          sortable: false,
        },
        {
          value: 'quarto',
          text: 'Quarto',
          class: 'text-no-wrap',
          sortable: false,
        },
        {
          value: 'motivo',
          text: 'Motivo',
          class: 'text-no-wrap',
          sortable: false,
        },
        {
          value: 'egb',
          text: 'EGB',
          class: 'text-no-wrap',
          sortable: false,
        },
        {
          value: 'data_previsao_alta',
          text: 'Data previsão alta',
          class: 'text-no-wrap text-center',
          sortable: false,
        },
        {
          value: 'actions',
          text: 'Ver internação',
          class: 'text-no-wrap text-center',
          width: 1,
          sortable: false,
        },
        {
          value: 'data-table-expand',
          text: 'PPP',
          sortable: false,
        },
      ],
      headersFinalizadas: [
        {
          value: 'data_alta',
          text: 'Data agendada',
          class: 'text-no-wrap',
          sortable: false,
        },
        {
          value: 'local',
          text: 'Local',
          class: 'text-no-wrap',
          sortable: false,
        },
        {
          value: 'quarto',
          text: 'Quarto',
          class: 'text-no-wrap',
          sortable: false,
        },
        {
          value: 'motivo',
          text: 'Motivo',
          class: 'text-no-wrap',
          sortable: false,
        },
        {
          value: 'egb',
          text: 'EGB',
          class: 'text-no-wrap',
          sortable: false,
        },
        {
          value: 'actions',
          text: 'Ver internação',
          class: 'text-no-wrap text-center',
          width: 1,
          sortable: false,
        },
        {
          value: 'data-table-expand',
          text: 'PPP',
          sortable: false,
        },
      ],
    };
  },
  computed: {
    internacoesAgendadas() {
      return _.sortBy(
        _.filter(
          this.internacoes as Internacao[],
          item => (item.datetime_agendamento
            && !item.datetime_internacao
            && !item.data_alta
            && !item.cancelled
          ),
        ),
        ['datetime_agendamento'],
        ['desc'],
      );
    },
    internacoesAtivas() {
      return _.sortBy(
        _.filter(
          this.internacoes as Internacao[],
          item => (item.datetime_internacao && !item.data_alta && !item.cancelled),
        ),
        ['datetime_internacao'],
        ['desc'],
      );
    },
    internacoesFinalizadas() {
      return _.sortBy(
        _.filter(
          this.internacoes as Internacao[],
          item => (item.data_alta && !item.cancelled),
        ),
        ['data_alta'],
        ['desc'],
      );
    },
  },
  methods: {
    egbStrings(egb: Egb) {
      return _.get(egbStrings, egb, null);
    },
    novaInternacao(internacao: Internacao) {
      this.$router.push({
        name: 'InternacoesVer',
        params: { internacaoId: internacao.id },
      });
    },
  },
});
